"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "basciano": {
    "dcfb5d97": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "cretone": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "edf7b1fb": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "feudo-da-borea": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67dee60f": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "feudo-da-sole": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4852addb": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-delle-grazie": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10be07ae": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "pantane": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f750013": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "pian-mulino": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c824c37d": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agostino": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "425db1aa": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "sbaragli": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5bce4719": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "vallone": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8507c6ae": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "villa-colle-portone": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a264fbb6": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "skipSearch": false
    }],
    "villa-frio": [{
      "hkey": "5046d931",
      "slug": "basciano",
      "name": "Basciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a9b8ab2": [{
      "hkey": "23f50826",
      "slug": "zampitti",
      "name": "Zampitti",
      "primary": true,
      "skipSearch": false
    }],
    "zampitto": [{
      "hkey": "23f50826",
      "slug": "zampitti",
      "name": "Zampitti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;